import PropTypes from "prop-types"
import classNames from "classnames"
import React from "react"
import {
  getSecondaryButtonStyles,
  getFadedButtonStyles,
} from "components/DYStackers/styles"
import iconCheck from "assets/icons/icon-check.svg"
import { InlineSVGIcon } from "components/Stacker/SvgIcon"
import { useI18nContext } from "i18n/i18n-react"
import { getDYArea } from "stackerConfig"

function SelectButton(props) {
  const { className, selected, onSelectClick } = props
  const { LL } = useI18nContext()
  const selectBtnClasses = classNames(
    "btn",
    "btn-rounded",
    "btn-select",
    {
      disabled: selected,
    },
    className
  )

  return (
    <button
      className={selectBtnClasses}
      onClick={onSelectClick}
      // style={getSecondaryButtonStyles()}
    >
      {!selected ? (
        <span>Select</span>
      ) : (
        <div>
          <InlineSVGIcon
            iconSvgText={iconCheck}
            alt={"check"}
            className={"align-top mr-1 select-div"} //d-inline
            style={{ display: "inline-block", height: 10, width: 10 }}
          />
          <span className="align-top">{LL[getDYArea()].selected()}</span>
        </div>
      )}
    </button>
  )
}

SelectButton.propTypes = {
  className: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  onSelectClick: PropTypes.func,
}

export default SelectButton
